import axiosRequest from "../universal/axiosService";
import { ENDPOINTS } from "../../apiConfig";

export const addAiCallApi = async (params) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.AICALLS.ADD}`,
    data: {
      coll: params?.coll,
      bulkPost: params?.bulkPost,
      accessId: params?.accessId,
      addedBy: params?.addedBy,
      payload: params?.payload,
    },
  });
};

export const fetchAllAiCallsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.AICALLS.GET_ALL}`,
    params: {
      coll: params.coll,
      pg: params.pg,
      lim: params.lim,
      ret: params.ret,
      ref: params.ref,
      extret: params.extret,
      fil: JSON.stringify(params.fil),
      incl: params.incl,
    },
  });
};

export const fetchAiCallDetailsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: `${ENDPOINTS.AICALLS.GET_DETAILS}`,
    params: {
      callId: params.callId,
      integrationId: params.integrationId,
    },
  });
};

export const updateAiCallApi = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.AICALLS.UPDATE}?coll=${params.coll}&uiid=${params.uiid}`,
    data: {
      payload: params.payload,
    },
  });
}